export default __webpack_public_path__ + "static/media/asics.1e84a867.svg";